export default __webpack_public_path__ + "static/media/rfcheckout_3.9373f2e8.png";